<div class="flex items-center">

@for (id of selectedIds; track $index) {
  <div class="app-table-input-id">
    @if (valueTemplate) {
      <ng-container *ngTemplateOutlet="valueTemplate; context: getValueTemplateContext(id)"></ng-container>
    } @else {
      {{ id }}
    }
  </div>
}
<input readonly>
<div class="grow flex items-center"><i class="material-icons app-table-input-icon ">arrow_drop_down</i></div>

<ng-template #dialogTemplate>
  <div class="dialog-backdrop">
    <div class="dialog-container">
      <div class="dialog-content">
        <div class="dialog-header">
          <h3 class="dialog-title">Select Items</h3>
          <div class="dialog-actions">
            <button mat-raised-button color="primary" (click)="onSelectClick()" class="select-button">
              Select
            </button>
            <app-close-button (closeClick)="onCloseClick()" [title]="'Close'"></app-close-button>
          </div>
        </div>
        <app-object-table
          class="app-object-table"
          [selectionType]="multi ? 'multiple' : 'single'"
          [selectedIds]="selectedIds"
          [objectName]="filterObjectName"
          (selectionChange)="onSelectedRowsChanged($event)"
        >
        </app-object-table>
      </div>
    </div>
  </div>
</ng-template>

</div>
